/**
 * Имя события «состав разделов изменился».
 *
 * Вынесено в модуль, чтобы отправитель и слушатель не разошлись в строке:
 * опечатка в имени события не вызывает ни ошибки компиляции, ни ошибки
 * времени выполнения — просто ничего не происходит.
 */
export const SECTIONS_CHANGED = 'bucor:sections-changed';
